import type { WebchatOrigin } from '../types/interfaces'

import { WHATSAPP_CHANNEL_ID } from './chatChannel'

/**
 * Identidad visible del cliente de WhatsApp.
 *
 * Un cliente que adoptó username puede llegar sin teléfono: el backend lo
 * identifica por su BSUID y manda `phone: null` junto a `username`. El nombre
 * de perfil se muestra tal cual lo escribió el cliente (".", "Geovanny 🤩"...)
 * y el `@username` va aparte, a su lado.
 */

/** `@username`, sin duplicar la arroba: Meta a veces ya la incluye. */
export const formatUsername = (username?: string | null): string => {
  const trimmed = username?.trim().replace(/^@+/, '')
  return trimmed ? `@${trimmed}` : ''
}

/** Lo que identifica al cliente cuando se muestra junto al nombre. */
export const getContactIdentifier = (phone?: string | null, username?: string | null): string =>
  phone?.trim() || formatUsername(username)

/** El nombre de perfil tal cual; solo si viene vacío, el `@username` o el teléfono. */
export const resolveContactName = (
  name?: string | null,
  username?: string | null,
  phone?: string | null,
): string => name?.trim() || formatUsername(username) || phone?.trim() || ''

/**
 * Clave con la que se identifica un contacto al elegir destinatarios: el
 * teléfono o, si no lo tiene, su BSUID. Con el teléfono a secas, todos los
 * contactos sin teléfono compartirían la clave vacía.
 */
export const contactKey = (contact: { phone?: string | null; bsuid?: string | null }): string =>
  contact.phone || (contact.bsuid ? `bsuid:${contact.bsuid}` : '')

/**
 * Campos de identidad del `Chat` del Oper a partir del snapshot del backend,
 * incluido el canal: de él depende por dónde y cómo se le escribe al cliente.
 */
export const toChatIdentity = (snapshot: {
  name?: string | null
  phone?: string | null
  username?: string | null
  channel_id?: string | null
  origin?: WebchatOrigin | null
}) => ({
  contact_name: resolveContactName(snapshot.name, snapshot.username, snapshot.phone),
  contact_phone: snapshot.phone?.trim() || '',
  contact_username: snapshot.username?.trim() || null,
  channel_id: snapshot.channel_id || WHATSAPP_CHANNEL_ID,
  origin: snapshot.origin ?? null,
})
